import { makeStyles, tokens, Button, MessageBar, MessageBarActions, MessageBarBody } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useEffectiveTenant } from '@shared/hooks/useEffectiveTenant';
import { useAllTenants } from '@shared/hooks/useTenantCatalog';

const useStyles = makeStyles({
  root: {
    marginBottom: tokens.spacingVerticalM,
  },
});

/**
 * Warning banner while the admin area works in a tenant other than the home tenant
 * (Phase 51 D-04). `isOverridden` is route-aware, so the banner hides itself outside `/admin`
 * and for anyone who is not a platform_admin.
 */
export function TenantBanner() {
  const styles = useStyles();
  const { t } = useTranslation('admin');
  const { isOverridden, effectiveTenantId, clear } = useEffectiveTenant();
  const { data } = useAllTenants();

  if (!isOverridden) return null;

  const name = data?.find((tenant) => tenant.id === effectiveTenantId)?.name ?? effectiveTenantId ?? '';

  return (
    <MessageBar intent="warning" className={styles.root}>
      <MessageBarBody>{t('tenantContext.banner', { name })}</MessageBarBody>
      <MessageBarActions>
        <Button onClick={clear}>{t('tenantContext.backToHome')}</Button>
      </MessageBarActions>
    </MessageBar>
  );
}

export default TenantBanner;
